module.exports = __webpack_public_path__ + "static/media/coil-small.8ac22882.svg";